<div *ngIf="imageFile.url !== ''" class="thumbnail-wrapper">
  <img [src]="imageFile.url" class ="thumbnail"/>
  <button class="remove-button" (click)="remove()">
    <i></i>
  </button>
</div>
